import { z } from "zod";
import { baseSpecShape, registerShell } from "./base.js";
export const sortSpecSchema = z.object({
    type: z.literal("sort"),
    ...baseSpecShape,
    buckets: z.array(z.string().min(1).max(24)).length(2),
    items: z
        .array(z.object({
        label: z.string().min(1).max(40),
        bucket: z.number().int().min(0).max(1),
    }))
        .min(3)
        .max(6),
});
export const sortShell = registerShell({
    id: "sort",
    version: 1,
    summary: "Assign items to 2 buckets.",
    chooseWhen: "The idea is a contrast or a category split — this kind versus that kind, happens here versus happens there.",
    interaction: "sorts things into two groups",
    invitation: "A handful of things to drop into the right pile.",
    schema: sortSpecSchema,
    required: ["buckets", "items"],
    properties: {
        buckets: {
            type: "array",
            minItems: 2,
            maxItems: 2,
            items: { type: "string", maxLength: 24 },
        },
        items: {
            type: "array",
            minItems: 3,
            maxItems: 6,
            description: "Both buckets must be used at least once.",
            items: {
                type: "object",
                required: ["label", "bucket"],
                properties: {
                    label: { type: "string", maxLength: 40 },
                    bucket: { type: "integer", minimum: 0, maximum: 1 },
                },
            },
        },
    },
    semanticIssues(spec) {
        const issues = [];
        const used = new Set(spec.items.map((i) => i.bucket));
        if (used.size !== 2) {
            issues.push("sort must place at least one item in each of the two buckets.");
        }
        const labels = new Set(spec.items.map((i) => i.label.trim().toLowerCase()));
        if (labels.size !== spec.items.length) {
            issues.push("sort items must all be different.");
        }
        if (spec.buckets[0]?.trim().toLowerCase() === spec.buckets[1]?.trim().toLowerCase()) {
            issues.push("sort buckets must be named differently.");
        }
        return issues;
    },
    example: {
        type: "sort",
        prompt: "Which happens while you're ASLEEP, and which while you're AWAKE?",
        buckets: ["Asleep 😴", "Awake 🙂"],
        items: [
            { label: "Filing away memories", bucket: 0 },
            { label: "Cleaning out the brain", bucket: 0 },
            { label: "Learning something new", bucket: 1 },
            { label: "Running around outside", bucket: 1 },
        ],
        right: "Nice! Your brain does the tidying up at night.",
        wrong: "Almost — the tidying and filing both happen while you sleep.",
    },
});
//# sourceMappingURL=sort.js.map